<template>
  <div id="secure">
    <NewTopMenu />
    <div class="container">
      <div
        class="field has-addons mt-4"
        style="padding: 0px 24px; margin-bottom: 24px"
      >
        <p class="control" v-for="btn in radioButtonArray" :key="btn.key">
          <button
            class="button is-small"
            :style="
              activeTab == btn.key &&
              'background-color: #000; color:#fff; font-weight: bold'
            "
            @click="activeTab != btn.key && handleClickMenu(btn.key)"
            :disabled="isLoading"
          >
            <span>{{ btn.title }}</span>
          </button>
        </p>
      </div>
      <div v-show="isLoading" style="z-index: 99999">
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          :is-full-page="false"
        >
        </loading>
      </div>
      <div class="card-n">
        <div class="card-content-n">
          <div class="content-n">
            <Filters
              :classDataSource="classDataSource"
              :itemDataSource="itemDataSource"
              :behaviorDataSource="
                filterItems.item == 1 ? behaviorDataSource : tagDataSource
              "
              :filterItems="filterItems"
              :handleDropdownChange="handleDropdownChange"
              :durationDataSource="durationDataSource"
              :monthDataSource="monthDataSource"
              :yearDataSource="yearDataSource"
              :handleUpdate="handleUpdate"
              :disable="isLoading"
              :fetchingData="fetchingData"
              :showModalBehavior="handleOpenModal"
            />
          </div>
        </div>
      </div>

      <div class="card-n mt-4">
        <div class="card-content-n">
          <div class="content">
            <div class="my-3" v-if="filterItems.item == 2">
              <span class="tag is-rounded is-light">{{
                tagDataSource.data.find(
                  (x) => x.value == filterItems.behaviorID
                ) == undefined
                  ? ""
                  : tagDataSource.data.find(
                      (x) => x.value == filterItems.behaviorID
                    ).label
              }}</span>
            </div>
            <div class="tags mt-3" v-if="filterItems.item != 2">
              <div v-for="(item, index) in computedItem" :key="index">
                <span
                  class="tag is-rounded is-light mr-2 text-ecllips"
                  v-if="index < 5"
                  >{{ item }}</span
                >
              </div>
              <div style="position: relative">
                <span
                  class="tag is-rounded is-light mr-2"
                  @mouseover="handleTooltip"
                  v-if="filterItems.behaviorID.length > 5"
                  >+ {{ filterItems.behaviorID.length - 5 }}</span
                >
                <div
                  :class="
                    showTooltip
                      ? 'tooltips is-active-tooltips p-2'
                      : 'tooltips p-2'
                  "
                  @mouseleave="handleTooltip"
                >
                  <div class="box tooltips-content">
                    <div v-for="(item, index) in computedItem" :key="index">
                      <span v-if="index > 5">
                        {{ item }}
                      </span>
                      <hr v-if="index > 5" class="my-2" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <Chart
                v-show="activeTab == 1"
                :chartData="chartData.data"
                :options="chartData.options"
                :isLoading="isLoading"
                :filterItems="filterItems"
                :item="filterItems.behaviorID"
                :handleChangeCategoryChart="handleChangeCategoryChart"
                :activeChartCategory="activeChartCategory"
                :chartItem="filterItems.item"
                :typeDuration="filterItems.duration"
                :tagDataSource="tagDataSource.data"
              />
              <Table
                v-show="activeTab == 2"
                :dataSource="studentDataSource.data"
                :loading="studentDataSource.loading"
                :handleSelectAllTable="handleSelectAllTable"
                :generateExcelSummary="generateExcelSummary"
                :filterItems="filterItems"
                :fetchingStudentReportV2="fetchingStudentReportV2"
                :title="
                  tagDataSource.data.find(
                    (x) => x.value == filterItems.behaviorID
                  )
                "
              />
              <List
                v-show="activeTab == 3"
                :dataSource="submissionDataSource.data"
                :loading="submissionDataSource.loading"
                :bottomScroll="bottomScroll"
                :onScroll="onScroll"
                :currentLimit="submissionDataSource.pagination.currentLimit"
                :currentPage="submissionDataSource.pagination.currentPage"
                :totalPage="submissionDataSource.pagination.totalPage"
                :totalLimit="submissionDataSource.pagination.totalLimit"
                :handleChandePaginationSize="handleChandePaginationSize"
                :fetchingSubmissionDataDetails="fetchingSubmissionDataDetails"
                :behaviorDataSource="behaviorDataSource.data"
                :handleSelectAll="handleSelectAll"
                :handleSelect="handleSelect"
                :handleRevoke="handleRevoke"
                :handleDownloadAsExcel="handleDownloadAsExcel"
              />
            </div>
          </div>
        </div>
      </div>

      <div style="height: 2em"></div>
    </div>
    <ModalBehavior
      :showModalBehavior="showModalBehavior"
      :closeModalBehavior="handleCloseModal"
      :dataSource="filterItems.item == 1 ? behaviorDataSource.data : tagDataSource.data"
      :value="filterItems.behaviorID"
      :handleUpdate="handleUpdate"
      :type="filterItems.item"
      :tagData="tagDataSource.data"
    />
  </div>
</template>

<script>
import NewTopMenu from "../NewTopMenu";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Chart from "./Chart.vue";
import Table from "./Table.vue";
import List from "./List.vue";
import Filters from "./Filters.vue";
import axios from "axios";
import { putZeroInFront } from "./CustomFunction";
import { getPayloadData } from "./getData";
import { ToastProgrammatic as Toast } from "buefy";
import ModalBehavior from "./ModalBehavior.vue";
const helper = require("../../../config/helper");

let radioButtonArray = [
  {
    key: 1,
    title: "Chart",
  },
  {
    key: 2,
    title: "Table",
  },
  {
    key: 3,
    title: "List",
  },
];

let itemsArray = [
  {
    label: "By Items",
    value: 1,
  },
  {
    label: "By Category",
    value: 2,
  },
];

let duration = [
  {
    label: "Today",
    value: 5,
  },
  {
    label: "Monthly",
    value: 1,
  },
  {
    label: "Yearly",
    value: 2,
  },
  {
    label: "Range",
    value: 3,
  },
  {
    label: "Daily",
    value: 4,
  },
];

let monthArray = [
  {
    label: "January",
    value: 1,
  },
  {
    label: "February",
    value: 2,
  },
  {
    label: "March",
    value: 3,
  },
  {
    label: "April",
    value: 4,
  },
  {
    label: "May",
    value: 5,
  },
  {
    label: "June",
    value: 6,
  },
  {
    label: "July",
    value: 7,
  },
  {
    label: "August",
    value: 8,
  },
  {
    label: "September",
    value: 9,
  },
  {
    label: "October",
    value: 10,
  },
  {
    label: "November",
    value: 11,
  },
  {
    label: "December",
    value: 12,
  },
];

let options = {
  responsive: true,
  maintainAspectRatio: false,
  layout: {
    padding: {
      left: 10,
      right: 10,
      top: 50,
      bottom: 0,
    },
  },
  plugins: {
    datalabels: {
      display: true,
      align: "end",
      anchor: "end",
      clamp: true,
      formatter: function (value, context) {
        // let label = context.chart.data.labels[context.dataIndex];
        return parseInt(value);
      },
      rotation: 0,
      padding: 0,
      margin: 0,
      font: {
        weight: "bold",
        size: 10,
      },
    },
  },
  legend: {
    display: false,
  },
  animation: {
    duration: 1000,
    easing: "easeInOutQuint",
  },
  scales: {
    xAxes: [
      {
        categoryPercentage: 0.8,
        barPercentage: 0.8,
        skipNull: true,
        stacked: false,
        minBarLength: 200,
        barThickness: "flex", // number (pixels) or 'flex'
        gridLines: {
          offsetGridLines: false,
          display: false,
        },
        ticks: {
          align: "start",
          padding: 5,
          fontSize: 9,
          beginAtZero: true,
          display: true,
          // max: 4000,
          maxRotation: 90,
          minRotation: 90,
          margin: 10,
          // stepSize: 1000,
        },
      },
    ],
    yAxes: [
      {
        barPercentage: 0.8,
        categoryPercentage: 0.8,
        skipNull: true,
        barThickness: "flex", // number (pixels) or 'flex'
        offset: true,
        display: false,
        gridLines: {
          offsetGridLines: false,
          display: false,
        },
        ticks: {
          align: "start",
          beginAtZero: true,
          display: true,
          // max: 4000,
          padding: 5,
          fontSize: 9,
          margin: 10,
          // stepSize: 1000,
        },
      },
    ],
  },
};
export default {
  name: "OverallReporting",
  components: {
    NewTopMenu,
    Chart,
    Table,
    List,
    Filters,
    Loading,
    ModalBehavior,
  },
  data() {
    var _this = this;
    let date = new Date();
    let currentYear = date.getFullYear();
    let currentMonth = date.getMonth() + 1;
    let currentDate = date.getDate();
    let firstDateCurrentMonth = new Date(currentYear, currentMonth);
    let yearDataSource = [
      {
        label: currentYear - 1,
        value: currentYear - 1,
      },
      {
        label: currentYear,
        value: currentYear,
      },
      {
        label: currentYear + 1,
        value: currentYear + 1,
      },
    ];
    return {
      showTooltip: false,
      showProgressBar: false,
      radioButtonArray: radioButtonArray,
      activeTab: 1,
      filterItems: {
        category: "school",
        item: 1,
        behaviorID: [],
        duration: 5,
        month: currentMonth,
        year: currentYear,
        range: {
          start: `${currentYear}-${putZeroInFront(
            currentMonth
          )}-${putZeroInFront(firstDateCurrentMonth.getDate())}`,
          end: `${currentYear}-${putZeroInFront(currentMonth)}-${putZeroInFront(
            currentDate
          )}`,
        },
        daily: `${currentYear}-${putZeroInFront(currentMonth)}-${putZeroInFront(
          currentDate
        )}`,
      },
      itemDataSource: {
        loading: true,
        data: itemsArray,
        errMsg: "",
      },
      classDataSource: {
        loading: true,
        data: [
          {
            label: "Whole Class",
            value: "school",
          },
        ],
        errMsg: "",
      },
      behaviorDataSource: {
        loading: true,
        data: [],
        errMsg: "",
      },
      tagDataSource: {
        loading: true,
        data: [],
        errMsg: "",
      },
      durationDataSource: {
        loading: true,
        data: duration,
        errMsg: "",
      },
      monthDataSource: {
        loading: true,
        data: monthArray,
        errMsg: "",
      },
      yearDataSource: {
        loading: true,
        data: yearDataSource,
        errMsg: "",
      },
      teacherDataSource: {
        loading: true,
        data: [],
        errMsg: "",
      },
      chartData: {
        data: {
          labels: [],
          datasets: [],
        },
        options: {
          ...options,
          onClick: function (evt, arr) {
            var selectedLabelColumn;
            var selectedLabelColumnTitle;
            this.getElementsAtEventForMode(evt, "x", 1).forEach(function (
              item
            ) {
              selectedLabelColumn = item._index;
              selectedLabelColumnTitle = item["_model"]["label"];
            });
            //alert("Column " + selectedLabelColumn + " was selected");

            try {
              var label = arr[0]["_model"].label; //this line is purely to throw error for empty bar
              _this.graphClickEvent(evt, arr);
            } catch (err) {
              _this.viewBarDetails(
                selectedLabelColumn,
                selectedLabelColumnTitle
              );
            }
          },
        },
      },
      submissionDataSource: {
        loading: false,
        data: [],
        errMsg: "",
        pagination: {
          currentPage: 1,
          currentLimit: 20,
          totalPage: 0,
          totalLimit: 0,
        },
      },
      studentDataSource: {
        loading: false,
        data: [],
        errMsg: "",
      },
      isLoading: false,
      bottomScroll: false,
      activeChartCategory: {
        title: "Submission Count",
        color: "#EC4899",
        border: "#EC4899",
        value: "Submission Count",
      },
      rawChatData: [],
      rawClassData: [],
      rawBehaviourData: [],
      showModalBehavior: false,
    };
  },
  watch: {
    activeChartCategory() {
      this.sumArrayChartItem(this.rawChatData);
    },
  },
  computed: {
    computedItem() {
      return this.filterItems.behaviorID.map((id) => {
        return this.behaviorDataSource.data.find((item) => item.value == id) ==
          undefined
          ? ""
          : this.behaviorDataSource.data.find((item) => item.value == id).label;
      });
    },
  },
  async mounted() {
    await this.getClassList();
    await this.getBehaviorList();
    await this.getTagList();
    await this.fetchingTeacher();

    const data = localStorage.getItem("filterItems");
    if (data == null || data == undefined) {
      this.handlePushRouter();
    } else {
      this.handleRoute();
    }
    // if (this.$route.params && this.$route.params.id) {
    //   this.handleRoute();
    // } else {
    //   this.handlePushRouter();
    // }
  },
  methods: {
    handleOpenModal() {
      this.showModalBehavior = true;
    },
    handleCloseModal() {
      this.showModalBehavior = false;
    },
    fetchingData() {
      this.isLoading = true;
      if (this.filterItems.item == 1) {
        if (this.activeTab == 1) {
          this.fetchingSubmissionDataV2();
        } else if (this.activeTab == 2) {
          this.fetchingStudentReportV2();
        } else if (this.activeTab == 3) {
          this.fetchingSubmissionDataDetails();
        } else {
          this.fetchingSubmissionDataV2();
        }
      } else {
        this.fetchingStudentReportV2();
      }
    },
    handleTooltip() {
      this.showTooltip = !this.showTooltip;
    },
    handleRoute() {
      const data = JSON.parse(localStorage.getItem("filterItems"));
      const tab = JSON.parse(localStorage.getItem("activeTab"));
      // let paramsquery = this.$route.params;
      // let obj = {};
      if (tab != null || tab != undefined) {
        this.activeTab = tab;
      }
      if (data != null || data != undefined) {
        // if (paramsquery.id) {
        //   let arr = paramsquery.id.split("&");
        //   for (let i = 0; i < arr.length; i++) {
        //     let value = arr[i].split("=");
        //     switch (value[0]) {
        //       case "page":
        //         this.activeTab = parseInt(value[1]);
        //         break;
        //       case "year":
        //         obj = {
        //           ...obj,
        //           year: parseInt(value[1]),
        //         };
        //         break;
        //       case "month":
        //         obj = {
        //           ...obj,
        //           month: parseInt(value[1]),
        //         };
        //         break;
        //       case "item":
        //         obj = {
        //           ...obj,
        //           item: parseInt(value[1]),
        //         };
        //         break;
        //       case "category":
        //         obj = {
        //           ...obj,
        //           category: value[1],
        //         };
        //         break;
        //       case "behaviorID":
        //         obj = {
        //           ...obj,
        //           behaviorID: value[1].includes(",")
        //             ? value[1].split(",")
        //             : [value[1]],
        //         };
        //         break;
        //       case "duration":
        //         obj = {
        //           ...obj,
        //           duration: parseInt(value[1]),
        //         };
        //         break;
        //       case "start":
        //         obj = {
        //           ...obj,
        //           range: {
        //             ...obj.range,
        //             start: value[1],
        //           },
        //         };
        //         break;
        //       case "end":
        //         obj = {
        //           ...obj,
        //           range: {
        //             ...obj.range,
        //             end: value[1],
        //           },
        //         };
        //         break;
        //       case "daily":
        //         obj = {
        //           ...obj,
        //           daily: value[1],
        //         };
        //         break;
        //       default:
        //         obj = this.filterItems;
        //         break;
        //     }
        //   }
        this.filterItems = data;
      }
      this.handlePushRouter();
    },
    handlePushRouter() {
      localStorage.setItem("filterItems", JSON.stringify(this.filterItems));
      localStorage.setItem("activeTab", JSON.stringify(this.activeTab));
      // this.$router.push({
      //   name: "OverallReportingDetails",
      //   params: {
      //     id: `page=${this.activeTab}&item=${this.filterItems.item}&category=${this.filterItems.category}&month=${this.filterItems.month}&year=${this.filterItems.year}&duration=${this.filterItems.duration}&daily=${this.filterItems.daily}&start=${this.filterItems.range.start}&end=${this.filterItems.range.end}&behaviorID=${this.filterItems.behaviorID}`,
      //   },
      // });
    },
    graphClickEvent(evt, arr) {
      if (evt != undefined && arr != undefined) {
        if (this.filterItems.item == 1) {
          const period = this.filterItems.duration;
          if (
            period == 4 ||
            period == 5 ||
            (period == 3 &&
              this.filterItems.range.start == this.filterItems.range.end)
          ) {
            const seletedLabel = arr[0]._view.label;
            let checkStr =
              typeof seletedLabel == "string"
                ? seletedLabel
                : seletedLabel.join("");
            const findItemBehavior = this.behaviorDataSource.data.find((x) =>
              x.label.includes(checkStr)
            ).value;
            this.filterItems = {
              ...this.filterItems,
              behaviorID: [findItemBehavior],
            };
          } else {
            const rawChatData = [...this.rawChatData];
            const findItem = rawChatData.find((x) =>
              x.title.includes(checkStr)
            ).data;
            let selectedData = findItem[0].actionDate;
            let year = selectedData.substring(0, 4);
            let month = selectedData.substring(4, 6);
            let day = selectedData.substring(6, 8);
            this.filterItems = {
              ...this.filterItems,
              duration: 4,
              daily: `${year}-${putZeroInFront(month)}-${putZeroInFront(day)}`,
            };
          }
          this.handleClickMenu(3);
        } else {
          this.handleClickMenu(2);
        }
        this.fetchingData();
      }
    },
    viewBarDetails(index, title) {
      if (index != undefined && title != undefined) {
        let checkStr = typeof title == "string" ? title : title.join("");
        if (this.filterItems.item == 1) {
          const period = this.filterItems.duration;
          if (
            period == 4 ||
            period == 5 ||
            (period == 3 &&
              this.filterItems.range.start == this.filterItems.range.end)
          ) {
            const findItem = this.behaviorDataSource.data.find((x) =>
              x.label.includes(checkStr)
            );

            this.filterItems = {
              ...this.filterItems,
              behaviorID: [findItem.value],
            };
          } else {
            const monthNames = [
              "Jan",
              "Feb",
              "Mar",
              "Apr",
              "May",
              "June",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
              "Dec",
            ];
            const labelDate =
              this.filterItems.item == 1 ? checkStr.split(/[ ,]+/) : checkStr;
            const findIndex =
              monthNames.findIndex((x) => x == labelDate[1]) + 1;
            let year = labelDate[2];
            let month = findIndex;
            let day = labelDate[0];
            this.filterItems = {
              ...this.filterItems,
              duration: 4,
              daily: `${year}-${putZeroInFront(month)}-${putZeroInFront(day)}`,
            };
          }
          this.handleClickMenu(3);
        } else {
          this.handleClickMenu(2);
        }
      }
      this.fetchingData();
    },
    handleChangeCategoryChart(title, color, border, value) {
      this.activeChartCategory = {
        title,
        color,
        border,
        value,
      };
    },
    handleChandePaginationSize(property, value) {
      let self = this;
      self.submissionDataSource = {
        ...self.submissionDataSource,
        pagination: {
          ...self.submissionDataSource.pagination,
          currentPage:
            property == "currentLimit"
              ? 1
              : self.submissionDataSource.pagination.currentPage,
          [property]: value,
        },
      };
      this.fetchingSubmissionDataDetails();
    },
    handleClickMenu(key) {
      const self = this;
      let currentbehavior = self.tagDataSource.data.find(
        (x) => x.value == self.filterItems.behaviorID
      );
      self.activeTab = key;

      this.chartData = {
        ...this.chartData,
        data: {
          labels: [],
          datasets: [],
        },
      };

      this.studentDataSource = {
        ...this.studentDataSource,
        data: [],
      };

      this.submissionDataSource = {
        ...this.submissionDataSource,
        data: [],
        pagination: {
          currentPage: 1,
          currentLimit: 20,
          totalPage: 0,
          totalLimit: 0,
        },
      };

      if (key === 1) {
        self.filterItems = {
          ...self.filterItems,
          item: 1,
          behaviorID: self.behaviorDataSource.data.map((x) => {
            return x.value;
          }),
        };
        // self.durationDataSource = {
        //   ...self.durationDataSource,
        //   data: duration,
        // };
      } else if (key === 2) {
        self.filterItems = {
          ...self.filterItems,
          item: 2,
          behaviorID:
            currentbehavior == undefined
              ? [self.tagDataSource.data[0].value]
              : self.filterItems.behaviorID,
          // duration: 1,
        };
        // self.studentDataSource = {
        //   ...self.studentDataSource,
        //   data: [],
        // };
        // self.durationDataSource = {
        //   ...self.durationDataSource,
        //   data: duration.filter((x) => x.value <= 2),
        // };
      } else if (key === 3) {
        const checking = self.behaviorDataSource.data.find(
          (x) => x.value == this.filterItems.behaviorID
        );
        self.filterItems = {
          ...self.filterItems,
          item: 1,
          behaviorID: !checking
            ? self.behaviorDataSource.data.map((x) => {
                return x.value;
              })
            : this.filterItems.behaviorID,
        };
        // self.durationDataSource = {
        //   ...self.durationDataSource,
        //   data: duration,
        // };
      }
      //       self.fetchingSubmissionDataDetails();
      //     } else {
      //       self.filterItems = {
      //         ...self.filterItems,
      //         item: 1,
      //         behaviorID: self.behaviorDataSource.data.map((x) => {
      //           return x.value;
      //         }),
      //       };
      //     }
      //   }

      this.handlePushRouter();
    },
    handleDropdownChange(property, value) {
      const self = this;
      let date = new Date();
      let currentYear = date.getFullYear();
      let currentMonth = date.getMonth() + 1;
      let currentDate = date.getDate();
      self.chartData = {
        ...self.chartData,
        data: {
          labels: [],
          datasets: [],
        },
      };
      self.submissionDataSource = {
        ...self.submissionDataSource,
        pagination: {
          currentPage: 1,
          currentLimit: 20,
          totalPage: 0,
          totalLimit: 0,
        },
      };

      switch (property) {
        case "item":
          if (value == 1) {
            self.filterItems = {
              ...self.filterItems,
              [property]: value,
              behaviorID: self.behaviorDataSource.data.map((x) => {
                return x.value;
              }),
            };
          } else {
            self.filterItems = {
              ...self.filterItems,
              [property]: value,
              behaviorID: [self.tagDataSource.data[0].value],
            };
          }

          self.activeTab =
            self.activeTab == 1 ? self.activeTab : self.activeTab == 2 ? 3 : 2;
          // self.handleUpdate(null, null);
          break;
        default:
          let firstDateCurrentMonth = new Date(currentYear, currentMonth);
          self.filterItems = {
            ...self.filterItems,
            range: {
              start: `${currentYear}-${putZeroInFront(
                currentMonth
              )}-${putZeroInFront(firstDateCurrentMonth.getDate())}`,
              end: `${currentYear}-${putZeroInFront(
                currentMonth
              )}-${putZeroInFront(currentDate)}`,
            },
            daily: `${currentYear}-${putZeroInFront(
              currentMonth
            )}-${putZeroInFront(currentDate)}`,
            [property == "day" ? "daily" : property]: value,
          };
        // self.handleUpdate(null, null);
      }
      this.handlePushRouter();
    },
    handleUpdate(property, selectedValue) {
      const self = this;
      if (property == "behaviorID" && selectedValue.length > 0) {
        self.filterItems = {
          ...self.filterItems,
          [property]: selectedValue,
        };
      }
      if (this.filterItems.behaviorID.length > 0) {
        this.handlePushRouter();
      } else {
        Toast.open({
          message: "Please Select item first!",
          type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
          duration: 5000,
        });
      }
      this.showModalBehavior = false;
    },
    async getClassList() {
      const self = this;
      self.classDataSource = {
        ...self.classDataSource,
        loading: true,
      };
      axios.defaults.responseType = "json";
      await axios
        .post(process.env.NEW_ENDPOINT + "/classes/list/", {
          token: localStorage.getItem("jwtTokenV2"),
          email: localStorage.getItem("email"),
        })
        .then((response) => {
          this.rawClassData = response.data.kelasList;
          const mapData = response.data.kelasList.map((item) => {
            return {
              label: `${item.level} ${item.name}`,
              value: item._id,
            };
          });
          self.classDataSource = {
            ...self.classDataSource,
            loading: true,
            data: [...self.classDataSource.data, ...mapData],
          };
        })
        .catch((e) => {
          self.classDataSource = {
            ...self.classDataSource,
            loading: false,
            errMsg: e,
          };
        });
    },
    async getBehaviorList() {
      const self = this;
      self.behaviorDataSource = {
        ...self.behaviorDataSource,
        loading: true,
      };
      axios.defaults.responseType = "json";
      await axios
        .post(process.env.NEW_ENDPOINT + "/behaviors/list/", {
          token: localStorage.getItem("jwtTokenV2"),
          email: localStorage.getItem("email"),
        })
        .then((response) => {
          this.rawBehaviourData = response.data;
          const mapData = response.data.map((item) => {
            return {
              label: item.name,
              value: item._id,
            };
          });
          if (self.filterItems.item == 1) {
            self.filterItems = {
              ...self.filterItems,
              behaviorID: mapData.map((x) => {
                return x.value;
              }),
            };
          }
          self.behaviorDataSource = {
            ...self.behaviorDataSource,
            data: [...self.behaviorDataSource.data, ...mapData],
            loading: false,
          };
        })
        .catch((e) => {
          self.behaviorDataSource = {
            ...self.behaviorDataSource,
            errMsg: e,
            loading: false,
          };

          this.getBehaviorList();
        });
    },
    async getTagList() {
      const self = this;
      self.tagDataSource = {
        ...self.tagDataSource,
        loading: true,
      };
      axios.defaults.responseType = "json";
      await axios
        .post(process.env.NEW_ENDPOINT + "/behaviors/tagList/", {
          token: localStorage.getItem("jwtTokenV2"),
          email: localStorage.getItem("email"),
        })
        .then((response) => {
          const mapData = response.data.map((item) => {
            return {
              label: item.name,
              value: item._id,
            };
          });
          if (self.filterItems.item == 2) {
            self.filterItems = {
              ...self.filterItems,
              behaviorID: mapData.map((x) => {
                return x.value;
              }),
            };
          }
          self.tagDataSource = {
            ...self.tagDataSource,
            data: [...self.tagDataSource.data, ...mapData],
            loading: false,
          };
        })
        .catch((e) => {
          self.tagDataSource = {
            ...self.tagDataSource,
            errMsg: e,
            loading: false,
          };
        });
    },
    async fetchingTeacher() {
      axios.defaults.responseType = "json";
      await axios
        .post(process.env.NEW_ENDPOINT + "/teachers/list/", {
          token: localStorage.getItem("jwtTokenV2"),
          email: localStorage.getItem("email"),
        })
        .then((res) => {
          this.teacherDataSource = {
            ...this.teacherDataSource,
            data: res.data,
          };
        });
    },
    async fetchingSubmissionDataDetails() {
      const self = this;

      if (self.filterItems.behaviorID.length != 0) {
        self.isLoading = true;
        let payload = getPayloadData(
          self.activeTab,
          self.filterItems,
          self.submissionDataSource.pagination
        );
        // delete payload.page;
        // delete payload.limit;
        payload = {
          ...payload,
          duration:
            self.filterItems.duration == 2 ? "yearly" : payload.duration,
        };

        self.submissionDataSource = {
          ...self.submissionDataSource,
          data: [],
          loading: true,
        };
        let paginationData = {
          totalLimit: 0,
          totalPage: 0,
        };
        axios.defaults.responseType = "json";
        await axios
          .post(process.env.NEW_ENDPOINT + `/submissions/detail`, payload)
          .then((response) => {
            paginationData = {
              totalLimit: response.data.totalItem,
              totalPage: response.data.totalItem / payload.page,
            };
            if (response.data.submissions.length > 0) {
              const remap = response.data.submissions.map((element) => {
                const getBehaviour = this.rawBehaviourData.find(
                  (item) => item._id == element.positiveID
                );
                return {
                  ...element,
                  scaleLimit: !getBehaviour.scaleLimit
                    ? null
                    : getBehaviour.scaleLimit,
                };
              });

              const appendKelasName = remap.map((element) => {
                return {
                  ...element,
                  class: !element.kelasID
                    ? element.kelasID
                    : !this.classDataSource.data.find(
                        (item) => item.value == element.kelasID
                      )
                    ? "Removed"
                    : this.classDataSource.data.find(
                        (item) => item.value == element.kelasID
                      ).label,
                };
              });

              const appendKelasID = appendKelasName.map((element) => {
                return {
                  ...element,
                  kelasID: !element.kelasID
                    ? element.kelasID
                    : !this.rawClassData.find(
                        (item) => item._id == element.kelasID
                      )
                    ? "Removed"
                    : this.rawClassData.find(
                        (item) => item._id == element.kelasID
                      ),
                };
              });

              const appendTeacherName = appendKelasID.map((x) => {
                return {
                  ...x,
                  teacherName:
                    x.teacherID.firstName == undefined
                      ? this.teacherDataSource.data.find(
                          (item) => item._id == x.teacherID
                        ) != undefined
                        ? this.teacherDataSource.data.find(
                            (item) => item._id == x.teacherID
                          ).firstName
                        : "-"
                      : x.teacherID.firstName,
                  teacherID:
                    x.teacherID.firstName == undefined
                      ? this.teacherDataSource.data.find(
                          (item) => item._id == x.teacherID
                        ) != undefined
                        ? this.teacherDataSource.data.find(
                            (item) => item._id == x.teacherID
                          )
                        : x.teacherID
                      : x.teacherID,
                };
              });

              self.submissionDataSource = {
                ...self.submissionDataSource,
                data: appendTeacherName,
                loading: false,
                pagination: {
                  ...self.submissionDataSource.pagination,
                  totalLimit:
                    payload.page == 1
                      ? paginationData.totalLimit
                      : self.submissionDataSource.pagination.totalLimit,
                  totalPage:
                    payload.page == 1
                      ? paginationData.totalPage
                      : self.submissionDataSource.pagination.totalPage,
                },
              };
              self.isLoading = false;
            } else {
              Toast.open({
                message: "No Submission found.",
                type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                duration: 5000,
              });
              self.isLoading = false;
            }
          })
          .catch((err) => {
            Toast.open({
              message: err,
              type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
              duration: 5000,
            });
            self.isLoading = false;
          });
      } else {
        self.isLoading = false;
        self.submissionDataSource = {
          ...self.submissionDataSource,
          data: [],
          loading: false,
        };
        Toast.open({
          message: "Please Select item first!",
          type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
          duration: 5000,
        });
      }
    },
    async fetchingSubmissionDataV2() {
      const self = this;
      self.chartData = {
        ...self.chartData,
        loading: true,
      };
      let array = [];

      let date = new Date();
      let currentYear = date.getFullYear();
      let currentMonth = date.getMonth() + 1;
      let currentDate = date.getDate();
      let payload = getPayloadData(self.activeTab, self.filterItems);
      // loop item
      delete payload.behaviorIDs;

      for (let i = 0; i < self.filterItems.behaviorID.length; i++) {
        payload = {
          ...payload,
          behaviorID: self.filterItems.behaviorID[i],
          startDate:
            self.filterItems.duration == 5
              ? `${currentYear}${putZeroInFront(currentMonth)}${putZeroInFront(
                  currentDate
                )}`
              : payload.startDate,
          endDate:
            self.filterItems.duration == 5
              ? `${currentYear}${putZeroInFront(currentMonth)}${putZeroInFront(
                  currentDate
                )}`
              : payload.endDate,
          // startDate: "20210901",
          // endDate: "20210901",
        };

        axios.defaults.responseType = "json";
        const response = await axios.post(
          process.env.MY_URL + "/submissionsV2/data",
          payload
        );
        if (response.status == 200) {
          let filterHasData = [];
          if (self.filterItems.duration == 2) {
            filterHasData = response.data.result.filter((x) => {
              if (
                x.studentCount != 0 &&
                x.submissionCount != 0 &&
                x.totalPoints != 0
              ) {
                return x;
              }
            });
          } else {
            filterHasData = response.data.result;
          }

          let findTitle = this.behaviorDataSource.data.find(
            (x) => x.value == self.filterItems.behaviorID[i]
          );
          if (findTitle) {
            let title = findTitle.label;
            array.push({ title, data: filterHasData });
          }
        }
      }

      self.rawChatData = array;
      this.sumArrayChartItem(array);
      self.isLoading = false;
    },
    generateColorBar(color, length, labels) {
      let arrayColors = [];
      let listOfLabel = labels;

      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth();
      let day = date.getDate();

      if (this.filterItems.duration < 4) {
        let currentDate =
          year + putZeroInFront(month + 1) + putZeroInFront(day);
        let findItem = listOfLabel.findIndex(
          (x) => x.data[0].actionDate === currentDate
        );
        for (let i = 0; i < length; i++) {
          if (findItem == i) {
            arrayColors.push("#01d1b2");
          } else {
            arrayColors.push(color);
          }
        }
      }
      return this.filterItems.duration < 4 ? arrayColors : color;
    },
    sumArrayChartItem(data) {
      let self = this;
      let copyArray = [...data];
      let newData = [];

      let newArr = [];
      for (let i = 0; i < copyArray.length; i++) {
        newArr.push(...copyArray[i].data);
      }

      let result = [];
      if (self.filterItems.duration == 1 || self.filterItems.duration == 2) {
        let arr = Object.values(
          newArr.reduce((r, { displayDate, actionDate, ...o }) => {
            Object.entries(o).forEach(([submissionCount, v]) => {
              r[actionDate] = r[actionDate] || { actionDate, displayDate };
              r[actionDate][submissionCount] =
                (+r[actionDate][submissionCount] || 0) + +v;
            });
            return r;
          }, {})
        );

        result = arr.map((x) => {
          return {
            title: x.displayDate,
            data: [x],
          };
        });
      } else if (self.filterItems.duration == 3) {
        if (self.filterItems.range.start != self.filterItems.range.end) {
          let arr = Object.values(
            newArr.reduce((r, { displayDate, actionDate, ...o }) => {
              Object.entries(o).forEach(([submissionCount, v]) => {
                r[actionDate] = r[actionDate] || { actionDate, displayDate };
                r[actionDate][submissionCount] =
                  (+r[actionDate][submissionCount] || 0) + +v;
              });
              return r;
            }, {})
          );

          result = arr.map((x) => {
            return {
              title: x.displayDate,
              data: [x],
            };
          });
        } else {
          result = copyArray;
        }
      } else {
        result = copyArray;
      }

      if (self.activeChartCategory.value == "Submission Count") {
        newData = result.map((x, i) => {
          return { title: x.title, point: parseInt(x.data[0].submissionCount) };
        });
      } else if (self.activeChartCategory.value == "Total Student") {
        newData = result.map((x) => {
          return { title: x.title, point: parseInt(x.data[0].studentCount) };
        });
      } else if (self.activeChartCategory.value == "Total Points") {
        newData = result.map((x) => {
          return { title: x.title, point: parseInt(x.data[0].totalPoints) };
        });
      } else {
        newData = [];
      }

      let sortingDecent =
        self.filterItems.duration == 5 ||
        self.filterItems.duration == 4 ||
        self.filterItems.duration == 2 ||
        (self.filterItems.duration == 3 &&
          self.filterItems.range.start == self.filterItems.range.end)
          ? newData.sort((a, b) => {
              return b.point - a.point;
            })
          : newData;

      let dataSetsArray = sortingDecent.map((item) => {
        return item.point;
      });

      const labels = sortingDecent.map((x) => {
        return (this.filterItems.duration == 4 ||
          this.filterItems.duration == 5 ||
          self.filterItems.duration == 2 ||
          (this.filterItems.duration == 3 &&
            this.filterItems.range.start == this.filterItems.range.end)) &&
          x.title.length > 30
          ? [
              x.title.substring(0, 30),
              x.title.substring(30, 60),
              x.title.substring(60, 75),
            ]
          : x.title;
      });

      self.chartData = {
        ...self.chartData,
        data: {
          labels,
          datasets: [
            {
              label: self.activeChartCategory.value,
              borderWidth: 2,
              hoverBorderColor: "#000000",
              backgroundColor: this.generateColorBar(
                self.activeChartCategory.color,
                dataSetsArray.length,
                result
              ),
              data: dataSetsArray,
            },
          ],
        },
        loading: false,
      };
    },
    async fetchingStudentReportV2() {
      const self = this;
      self.studentDataSource = {
        ...self.studentDataSource,
        loading: true,
      };
      // self.isLoading = false
      let payload = getPayloadData(self.activeTab, self.filterItems);
      delete payload.behaviorIDs;
      delete payload.page;
      delete payload.limit;
      delete payload.startDate;
      delete payload.endDate;
      payload = {
        ...payload,
        categoryID: self.filterItems.category,
      };

      axios.defaults.responseType = "json";
      await axios
        .post(process.env.NEW_ENDPOINT + "/students/list", payload)
        .then((response) => {
          if (response.data.length > 0) {
            self.fetchingSummary(response.data);
          } else {
            Toast.open({
              message: "No students found for the given category",
              type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
              duration: 5000,
            });
            self.isLoading = false;
          }
        })
        .catch(() => {
          Toast.open({
            message: "No students found for the given category",
            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
            duration: 5000,
          });
          self.isLoading = false;
        });
    },
    async fetchingSummary(data) {
      const self = this;

      self.chartData = {
        ...self.chartData,
        data: {
          labels: [],
          datasets: [],
        },
      };

      let promises = [];
      let filterData = getPayloadData(self.activeTab, self.filterItems);
      let startDate = filterData.startDate;
      let endDate = filterData.endDate;
      let categoryID = filterData.categoryID[0];
      let studentDataCopy = data;

      try {
        for (var i = 0; i < studentDataCopy.length; i++) {
          promises.push(
            await axios.post(
              process.env.MY_URL + "/api/reportsV2/summaryWithDetails",
              {
                studentID: studentDataCopy[i]._id,
                startDate: startDate,
                endDate: endDate,
                categoryID: categoryID,
              }
            )
          );

          let summaryResult = await Promise.all(promises);
          if (studentDataCopy.length == summaryResult.length) {
            let summaryData = [];

            for (var i = 0; i < summaryResult.length; i++) {
              summaryData.push(summaryResult[i].data);
            }

            self.studentDataSource = {
              ...self.studentDataSource,
              data: summaryData,
              loading: false,
            };

            let mapData = summaryData.map((x) => {
              return x.category.items;
            });

            let newArr = [];
            let result = [];
            for (let i = 0; i < mapData.length; i++) {
              newArr.push(...mapData[i]);
            }

            let arr = Object.values(
              newArr.reduce(
                (r, { _id, name, maxYearlyScale, maxDailyScale, ...o }) => {
                  Object.entries(o).forEach(([points, v]) => {
                    r[_id] = r[_id] || {
                      _id,
                      name,
                      maxYearlyScale,
                      maxDailyScale,
                    };
                    r[_id][points] = (+r[_id][points] || 0) + +v;
                  });
                  return r;
                },
                {}
              )
            );

            result = arr.map((x) => {
              return {
                title: x.name,
                data: [x],
              };
            });

            const labels = result.map((x) => {
              return x.title.length > 30
                ? [
                    x.title.substring(0, 30),
                    x.title.substring(30, 60),
                    x.title.substring(60, 150),
                  ]
                : x.title;
            });

            const points = result.map((x) => {
              let point = x.data[0].totalPoints;
              return point;
            });

            let newData = {
              labels,
              datasets: [
                {
                  label: "Points",
                  backgroundColor: "#00BFF7",
                  data: points,
                },
              ],
            };

            self.chartData = {
              ...self.chartData,
              data: newData,
            };
            self.isLoading = false;
          }
        }
      } catch (err) {
        self.chartData = {
          ...self.chartData,
          data: {
            labels: [],
            datasets: [],
          },
        };
        self.isLoading = false;
      }
    },
    handleSelectAll() {
      const self = this;
      if (!self.selectAll) {
        let newData = self.submissionDataSource.data.map((x) => {
          return {
            ...x,
            checked: true,
          };
        });
        self.submissionDataSource = {
          ...self.submissionDataSource,
          data: newData,
        };
      } else {
        let newData = self.submissionDataSource.data.map((x) => {
          return {
            ...x,
            checked: false,
          };
        });
        self.submissionDataSource = {
          ...self.submissionDataSource,
          data: newData,
        };
      }
      self.selectAll = !self.selectAll;
    },
    handleSelect(id) {
      const self = this;
      let newData = [...self.submissionDataSource.data];
      let index = newData.findIndex((x) => x._id === id);
      let item = newData[index];

      let obj = {
        ...item,
        checked: !item.checked,
      };

      newData.splice(index, 1, { ...item, ...obj });
      self.submissionDataSource = {
        ...self.submissionDataSource,
        data: newData,
      };
    },
    setCheckedValue(dataType, id, studentID, actionDate) {
      return (
        "1:" + dataType + "|2:" + id + "|3:" + studentID + "|4:" + actionDate
      );
    },
    handleRevoke() {
      let self = this;
      this.$swal.fire({
        title: "Are you sure?",
        text: "Are you sure you want to revoke the selected submissions?",
        showCancelButton: true,
        confirmButtonText: "Yes, revoke",
        showLoaderOnConfirm: true,
        preConfirm: () => {
          var submissionsToRevoke = [];
          let copyData = [...self.submissionDataSource.data];
          const selectedData = copyData.filter((x) => {
            if (x.checked) return x;
          });
          selectedData.forEach(function (element) {
            if (element.checked) {
              var elementID = self.setCheckedValue(
                element.dataType,
                element._id,
                element.studentID._id,
                element.actionDate
              );
              submissionsToRevoke.push(elementID);
            }
          });

          axios.defaults.responseType = "json";
          return axios
            .post(process.env.NEW_ENDPOINT + "/submissions/revoke/", {
              token: localStorage.getItem("jwtTokenV2"),
              email: localStorage.getItem("email"),
              submissionsToRevoke: submissionsToRevoke,
            })
            .then((response) => {
              self.isLoading = false;
              if (response.data.success == false) {
                this.$swal.showValidationMessage(`Request failed`);
                self.submissionDataSource = {
                  ...self.submissionDataSource,
                  data: copyData.map((x) => {
                    return {
                      ...x,
                      checked: false,
                    };
                  }),
                };
                Toast.open({
                  message: response.data.msg,
                  type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                  duration: 5000,
                });
              } else {
                const removeData = copyData.filter((x) => {
                  if (!x.checked) return x;
                });
                self.submissionDataSource = {
                  ...self.submissionDataSource,
                  data: removeData,
                };
                Toast.open({
                  color: "is-dark", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                  message: response.data.msg,
                  type: "is-success",
                  duration: 3000,
                });
              }
            });
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
      });
    },
    handleDownloadAsExcel() {
      let self = this;

      let copyData = [...self.submissionDataSource.data];
      const data = copyData.filter((x) => {
        if (x.checked) return x;
      });

      let payload = getPayloadData(
        self.activeTab,
        self.filterItems,
        self.submissionDataSource.pagination
      );
      payload = {
        ...payload,
        data: data,
      };
      delete payload.page;
      delete payload.limit;
      axios.defaults.responseType = "blob";
      axios
        .post(
          process.env.MY_URL + "/exportToExcelV2/submissionDetails",
          payload
        )
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Submission Details.xlsx");
          document.body.appendChild(link);
          link.click();
          self.isLoading = false;
        })
        .catch((e) => {
          self.isLoading = false;
          if (e.response.status === 401) {
            Toast.open({
              message: "Unauthorized access. Please re-login.",
              type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
              duration: 5000,
            });
          } else {
            Toast.open({
              message: "Error: " + e.response.data.msg,
              type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
              duration: 5000,
            });
          }
        });
    },
    onScroll(e) {
      // const { target } = e;
      // const self = this;
      // if (
      //   Math.ceil(target.scrollTop) >=
      //   target.scrollHeight - target.offsetHeight
      // ) {
      // if (
      //   self.submissionDataSource.data &&
      //   self.submissionDataSource.data.length > 0
      // ) {
      // self.bottomScroll = true;
      // self.submissionDataSource = {
      //   ...self.submissionDataSource,
      //   pagination: {
      //     ...self.submissionDataSource.pagination,
      //     currentLimit:
      //       self.submissionDataSource.pagination.currentLimit + 10,
      //   },
      // };
      // self.fetchingSubmissionDataDetails();
      // }
      // }
    },
    handleSelectAllTable() {
      const self = this;
      if (!self.selectAll) {
        let newData = self.studentDataSource.data.map((x) => {
          return {
            ...x,
            checked: true,
          };
        });
        self.studentDataSource = {
          ...self.studentDataSource,
          data: newData,
        };
      } else {
        let newData = self.studentDataSource.data.map((x) => {
          return {
            ...x,
            checked: false,
          };
        });
        self.studentDataSource = {
          ...self.studentDataSource,
          data: newData,
        };
      }
      self.selectAll = !self.selectAll;
    },
    async generateExcelSummary() {
      let self = this;
      self.studentDataSource = {
        ...self.studentDataSource,
        loading: true,
      };
      var studentList = [];
      axios.defaults.responseType = "json";
      if (self.filterItems.category == "school") {
        //get the students for all school
        var getResult = await axios.post(
          process.env.NEW_ENDPOINT + "/students/list",
          {
            token: localStorage.getItem("jwtTokenV2"),
            email: localStorage.getItem("email"),
            category: "school",
            categoryID: "-",
          }
        );
        studentList = getResult.data;
      } else {
        //get the students for the given kelasID
        var getResult = await axios.post(
          process.env.NEW_ENDPOINT + "/students/list",
          {
            token: localStorage.getItem("jwtTokenV2"),
            email: localStorage.getItem("email"),
            category: "class",
            categoryID: self.filterItems.category,
          }
        );
        studentList = getResult.data;
      }

      if (studentList.length < 1) {
        Toast.open({
          message: "No students found for the given category",
          type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
          duration: 5000,
        });
        return false;
      }
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      if (self.filterItems.duration == 2) {
        axios.defaults.responseType = "json";
        var promises = [];
        //     self.showProgressBar = true;
        // self.pbValue = 0;

        var startDate = self.filterItems.year + "0101"; //for yearly, will start at 1 Jan
        var endDate =
          self.filterItems.year +
          "" +
          putZeroInFront(month) +
          "" +
          putZeroInFront(day); //for yearly, get only until the current day

        var tempValue = studentList.length;
        // var currentProgress = tempValue;
        currentProgress = 100 / tempValue; //+1 since generating excel is the added 1

        //     //now get each student's summary from the new endpoint
        try {
          for (var i = 0; i < studentList.length; i++) {
            promises.push(
              await axios.post(process.env.MY_URL + "/api/reportsV2/summary", {
                studentID: studentList[i]._id,
                startDate: startDate,
                endDate: endDate,
                categoryID: self.filterItems.behaviorID[0],
              })
            );
            // this.pbValue = this.pbValue + currentProgress;
          }
          var yearlySummaryTemp = await Promise.all(promises);
          var yearlySummary = [];
          for (var i = 0; i < yearlySummaryTemp.length; i++) {
            yearlySummary.push(yearlySummaryTemp[i].data);
          }
          var excelFileName = "Summary for " + self.filterItems.year;
          //now pass this data to generate excel
          axios.defaults.responseType = "blob";
          axios
            .post(process.env.MY_URL + "/exportToExcelV2/overallAnalysis", {
              token: localStorage.getItem("jwtTokenV2"),
              email: localStorage.getItem("email"),
              category: "summary",
              submissionData: yearlySummary,
            })
            .then((response) => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", excelFileName + ".xlsx");
              document.body.appendChild(link);
              link.click();
              self.studentDataSource = {
                ...self.studentDataSource,
                loading: false,
              };
            })
            .catch((e) => {
              self.studentDataSource = {
                ...self.studentDataSource,
                loading: false,
              };
              if (e.response.status === 401) {
                Toast.open({
                  message: "Unauthorized access. Please re-login.",
                  type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                  duration: 5000,
                });
              } else {
                Toast.open({
                  message: "Error: " + e.response.data.msg,
                  type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                  duration: 5000,
                });
              }
            });
        } catch (err) {
          Toast.open({
            message: "Sorry, an error has occurred: " + err,
            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
            duration: 5000,
          });
        } finally {
          self.studentDataSource = {
            ...self.studentDataSource,
            loading: false,
          };
          self.showProgressBar = false;
        }
      } else {
        var strMonth = putZeroInFront(self.filterItems.month);
        var daysInMonth = helper.getDaysInMonth(
          putZeroInFront(self.filterItems.month),
          self.filterItems.year
        );
        let startDate = self.filterItems.year + "" + strMonth + "01";
        let endDate = self.filterItems.year + "" + strMonth + "" + daysInMonth;
        axios.defaults.responseType = "json";
        var promises = [];
        var tempValue = studentList.length;
        var currentProgress = tempValue;
        currentProgress = 100 / tempValue; //+1 since generating excel is the added 1
        //now get each student's summary from the new endpoint
        try {
          for (var i = 0; i < studentList.length; i++) {
            promises.push(
              await axios.post(process.env.MY_URL + "/api/reportsV2/summary", {
                studentID: studentList[i]._id,
                startDate: startDate,
                endDate: endDate,
                categoryID: self.filterItems.behaviorID[0],
              })
            );
          }
          var allItems = await Promise.all(promises);
          var summary = [];
          for (var i = 0; i < allItems.length; i++) {
            summary.push(allItems[i].data);
          }
          var excelFileName = "Summary from " + startDate + " to " + endDate;
          //       //now pass this data to generate excel
          axios.defaults.responseType = "blob";
          axios
            .post(process.env.MY_URL + "/exportToExcelV2/overallAnalysis", {
              token: localStorage.getItem("jwtTokenV2"),
              email: localStorage.getItem("email"),
              category: "summary",
              submissionData: summary,
            })
            .then((response) => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", excelFileName + ".xlsx");
              document.body.appendChild(link);
              link.click();
              self.studentDataSource = {
                ...self.studentDataSource,
                loading: false,
              };
            })
            .catch((e) => {
              self.studentDataSource = {
                ...self.studentDataSource,
                loading: false,
              };
              if (e.response.status === 401) {
                Toast.open({
                  message: "Unauthorized access. Please re-login.",
                  type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                  duration: 5000,
                });
              } else {
                Toast.open({
                  message: "Error: " + e.response.data.msg,
                  type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                  duration: 5000,
                });
              }
            });
        } catch (err) {
          Toast.open({
            message: "Sorry, an error has occurred: " + err,
            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
            duration: 5000,
          });
        } finally {
          self.studentDataSource = {
            ...self.studentDataSource,
            loading: false,
          };
          self.showProgressBar = false;
        }
      }
    },
  },
};
</script>

<style>
.card-n {
  background-color: white;
  border-radius: 0.25rem;
  -webkit-box-shadow: 0 0.5em 1em -0.125em rgb(10 10 10 / 10%),
    0 0px 0 1px rgb(10 10 10 / 2%);
  box-shadow: 0 0.5em 1em -0.125em rgb(10 10 10 / 10%),
    0 0px 0 1px rgb(10 10 10 / 2%);
  color: #4a4a4a;
  max-width: 100%;
  position: relative;
}
.card-content-n {
  padding: 1.5rem;
}

.text-ecllips {
  padding-top: 3px;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px;
  display: block !important;
}

.tooltips {
  position: absolute;
  overflow: hidden;
  display: none;
  top: 0px;
  left: 0px;
  padding-top: 32px !important;
  z-index: 20;
  font-size: 0.7rem;
}

.tooltips-content {
  max-height: 350px;
  max-width: 400px;
  overflow: auto;
}

.is-active-tooltips {
  display: block !important;
}
</style>



// WEBPACK FOOTER //
// src/components/OverallReporting/OverallReporting.vue